import { BehaviorSubject } from 'rxjs';

import { ShareState } from './types';

// Контекст шаринга
export const shareContext$ = new BehaviorSubject<ShareState>({
  IsShareLoading: true,
  IsStorageShareLoading: true,
  ShareType: null,
  ShareData: null,
  ShareShortLink: null,
  StorageShareData: null,
  StorageShareShortLink: null,
  ShareTab: null
});
